import React, {
	useEffect,useMemo,
	useState
} from 'react';

// ref is the ref of the HTML element to check if is visible on screen

export default function useOnScreen(ref, options) {
	const [isIntersecting, setIntersecting] = useState(false)

	const observer = useMemo(() => new IntersectionObserver(
		([entry]) => setIntersecting(entry.isIntersecting),
		options
	),
	[ref])


	useEffect(() => {
		if (ref.current) {
			observer?.observe(ref.current);
			return () => observer.disconnect();
		}
	},
	[])

	return isIntersecting;
}
